import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { CardMediaRow } from "components/Card";
import { AdvancedButton } from "components/Buttons";
import { Tag } from "components/Tags";
import { TAG_COLORS, TAG_SIZE } from "components/Tags/Tag";
import { InterviewQuestionVideoThumbnailState } from "components/Missions/Roles";

/**
 * RoleInterviewQuestionCard
 *
 * One video interview question, rendered by CardList.
 *
 * @param {Object}    data        The interview question
 * @param {Boolean}   loading     Show placeholders instead of the question
 * @param {Boolean}   canEdit     Whether the question may be changed
 * @param {Function}  getOptions  Returns the advanced menu options for the question
 */
const RoleInterviewQuestionCard = ({ data: question, loading, canEdit, getOptions, ...props }) => {
  if (loading) return <CardMediaRow loading {...props} />;

  const options = canEdit ? getOptions?.(question) : null;

  return (
    <CardMediaRow
      media={<InterviewQuestionVideoThumbnailState question={question} title={question.title} />}
      title={question.title}
      meta={
        <Tag {...TAG_COLORS.gray} size={TAG_SIZE.small}>
          <FormattedMessage
            id="Missions.Roles.RoleVetting.Interviews.AnswerLength"
            values={{ value: question.timeLimitSeconds / 60 }}
          />
        </Tag>
      }
      description={question.description}
      actions={options?.length > 0 && <AdvancedButton options={options} />}
      {...props}
    />
  );
};

RoleInterviewQuestionCard.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
  canEdit: PropTypes.bool,
  getOptions: PropTypes.func,
};

export default RoleInterviewQuestionCard;
